import { Icon } from './Icon'

/**
 * The diff a human reads before anything becomes a commit. That review is the
 * safety step the whole flow rests on, so it is a first-class view rather than a
 * debugging aid.
 */
export function DiffView({ diff }: { diff: string }) {
  if (!diff || diff === 'no staged changes') {
    return (
      <div className="empty">
        <span className="empty__icon">
          <Icon name="diff" size={20} />
        </span>
        <span className="empty__title">Nothing staged</span>
        <span className="empty__text">
          Edits appear here as a diff once they are saved. Saving stages a change; it does not
          commit it.
        </span>
      </div>
    )
  }
  return (
    <pre className="diff">
      {diff.split('\n').map((line, i) => (
        <div key={i} className={`diff__line diff__line--${kind(line)}`}>
          {line || ' '}
        </div>
      ))}
    </pre>
  )
}

function kind(line: string): string {
  if (line.startsWith('+++') || line.startsWith('---')) return 'file'
  if (line.startsWith('@@')) return 'hunk'
  if (line.startsWith('+')) return 'add'
  if (line.startsWith('-')) return 'del'
  return 'ctx'
}
